import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const ProfileClimateForm = ({
  visible,
  onClose,
  node,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Dia ensolarado", value: 1 },
    { label: "Noite aberta", value: 2 },
    { label: "Chuvoso", value: 4 },
    { label: "Nublado", value: 8 },
    { label: "Dia parcialmente nublado", value: 16 },
    { label: "Noite parcialmente nublada", value: 32 },
    { label: "Neblina", value: 64 },
    { label: "Ventania", value: 128 },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.ProfileClimate}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        timerange={false}
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
